
export class TicketTabInfo {
  isNewTicket: boolean;
  webOrderID: string;
  distributorID: string;
  disabled: boolean;
  removable: boolean;
  title: string;
  active: boolean;
  ticketID: number;
  viewTicket: boolean;
  editTicket: boolean;
  disputeTicket: boolean;
  tabIndex: number;
  ticketNumber: string;
  modifiedDistributor: boolean;
  isTeamTicket: boolean;
  isFormTicket: boolean;
  isFdTicket: boolean;
  country: String;
}




// WEBPACK FOOTER //
// ./src/app/customerservice/models/tickets-tab.model.ts